export default __webpack_public_path__ + "img/bf18afaad2d2d58cb9b8c55ec13b5f9f.png";